import RecordList from "../components/RecordList";
function AttendancePage() { return <RecordList title="Attendance" endpoint="/attendance" columns={[["date", "Date"], ["driverName", "Driver"], ["checkInTime", "Check in"], ["checkOutTime", "Check out"], ["status", "Status"], ["overtimeHours", "Overtime hours"]]} />; }
export default AttendancePage;
